import TabbedModal from './TabbedModal';

export default TabbedModal;
